import { remove } from 'app/utils/axios/kheti'

const withdrawDemoMaterialRequest = async (requestId: number) => {
  const url = `/approvals/v1/demo-material-issuance/requests/${requestId}`
  return remove<void>(url)
}

export default withdrawDemoMaterialRequest
